import React, { Component } from 'react';
import firebase from './../Firestore'
//import { Link } from 'react-router-dom';
import FileUploader from "react-firebase-file-uploader";
import NavBar from './NavBar'

import config from 'react-global-configuration';


class Edit extends Component {

  constructor(props) {
    super(props);
    this.unsubscribe = null;
    this.state = {
      key: '',
      nombre: '',
      imagen: '',
      orden: '',
      seFracciona: '',
      diseno: '',
      isUploading: false,
      progress: 0,
      imagenURL: ''
    };
  }

  async componentDidMount() {
    const ref = firebase.firestore().collection('categoria').doc(this.props.match.params.id);
    this.unsubscribe = await ref.get().then((doc) => {
      if (doc.exists) {
        const categoria = doc.data();
        this.setState({
          key: doc.id,
          nombre: categoria.nombre,
          imagen: categoria.imagen,
          orden: categoria.orden,
          seFracciona: categoria.seFracciona,
          diseno: categoria.diseno,
          });
      } else {
        console.log("No such document!");
      }
    });
  }

  onChange = (e) => {
    const state = this.state
    //console.log(e.target.name, e.target.value)

    state[e.target.name] = e.target.value;
    this.setState({categoria:state});

  }


  onSubmit = (e) => {
    e.preventDefault();

    const { nombre, imagen, orden, seFracciona, diseno } = this.state;

    const updateRef = firebase.firestore().collection('categoria').doc(this.state.key);


    let quitarImagen = undefined;
    if (typeof e.target.quitarImagen === 'undefined'){
      quitarImagen = false;
      console.log("aquiii")
    } else {
      quitarImagen = e.target.quitarImagen.checked? '': imagen;
    }

    updateRef.set({
      nombre,
      //imagen: e.target.quitarImagen.checked? '': imagen,
      imagen: quitarImagen,
      orden: Number(this.state.orden),
      seFracciona: Boolean(this.state.seFracciona),
      diseno,
    }).then((docRef) => {
      this.setState({
        key: '',
        nombre: '',
        imagen: '',
        imagenURL: '',
        orden: '',
        seFracciona: '',
        diseno: ''
      });
      this.props.history.push("/admin/categoria/show/"+this.props.match.params.id)
    })
    .catch((error) => {
      console.error("Error adding document: ", error);
    });
  }


  handleUploadStart = () => this.setState({ isUploading: true, progress: 0 });
  handleProgress = progress => this.setState({ progress });
  handleUploadError = error => {
    this.setState({ isUploading: false });
    console.error(error);
  };
  handleUploadSuccess = filename => {
    this.setState({ imagen: filename, progress: 100, isUploading: false });
    firebase
      .storage()
      .ref("categorias")
      .child(filename)
      .getDownloadURL()
      .then(url => this.setState({ imagen: url }));
  };

  render() {
    return (
      <div className="container">
        <NavBar history={this.props.history} />
        <div className="panel panel-default">
          <div className="panel-heading">
            <h3 className="panel-title">
              EDITAR CATEGORIA
            </h3>
          </div>
          <div className="panel-body">
            <form onSubmit={this.onSubmit}>
              <div className="form-group">
                <label htmlFor="nombre"><strong>Nombre:</strong></label>
                <input type="text" className="form-control" name="nombre" value={this.state.nombre} onChange={this.onChange} placeholder="Nombre" />
              </div>

              <span className="d-block"><strong>Imagen</strong> de la categoria (ideal 400px ancho x 100px alto):</span><br/>
              {this.state.isUploading && <p>Progress: {this.state.progress}</p>}
              {this.state.imagen &&
                <div>
                <input type="checkbox" name="quitarImagen" value="quitar" />Quitar imagen<br />
                <img src={this.state.imagen} alt={this.state.nombre} />
                </div>
              }
              <FileUploader
                accept="image/*"
                name="categoria"
                randomizeFilename
                storageRef={firebase.storage().ref("categorias")}
                onUploadStart={this.handleUploadStart}
                onUploadError={this.handleUploadError}
                onUploadSuccess={this.handleUploadSuccess}
                onProgress={this.handleProgress}
                maxHeight="100"
                maxWidth="400"
              />


            <div className="form-group mt-2">
                <label htmlFor="orden" className="mb-0"><strong>Orden:</strong></label>
                <small className="d-block mt-0">La posición en la que aparecerá listada (0 es la mas arriba)</small>
                <input type="number" className="form-control" name="orden" value={this.state.orden} onChange={this.onChange} placeholder="Orden" />
              </div>

              <div className="form-group">

                <select value={this.state.seFracciona} name="seFracciona" onChange={this.onChange} className="custom-select mt-2">
                  <option value={false}>No se Fracciona</option>
                  <option value={true}>Se fracciona</option>
                </select>

              </div>

              <div className="form-group">
                <label htmlFor="diseno"><strong>Diseño</strong> para los productos de esta categoria:</label>
                <small className="d-block mt-0">Hay diseño especial para pizza y empanadas, al resto otorgarle el genérico</small>
                <select value={this.state.diseno} name="diseno" onChange={this.onChange} className="custom-select mt-2">
                  <option value="generico">Lista de productos genericos</option>
                  <option value="empanada">Lista de empanadas</option>
                  <option value="pizza">Formato para pizzas</option>
                </select>

              </div>
              <button type="submit" className="btn btn-success">Actualizar</button>
            </form>
          </div>
        </div>
      </div>
    );
  }
}

export default Edit;
